import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b227769"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-input-container" }
const _hoisted_2 = {
  key: 0,
  class: "c-input-label"
}
const _hoisted_3 = { class: "c-input-box" }
const _hoisted_4 = ["value", "placeholder", "min", "max"]
const _hoisted_5 = { class: "c-input-btn-icon" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1681979626739",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "12789",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3c-3.8 5.3-0.1 12.7 6.5 12.7h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z",
    "p-id": "12790",
    fill: "#e6e6e6"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1681979740758",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "2278",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3 0.1-12.7-6.4-12.7z",
    "p-id": "2279",
    fill: "#e6e6e6"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "c-input-error"
}

import { computed, onMounted, reactive } from "vue";
import { emitter } from '@/utils/eventBus'
interface RullProp {
  required?: boolean
  message: string
}
// TS 别名
// 定义验证规则数组的数据类型
type RulesProp = RullProp[];

interface InputProps {
  value?: string | number
  label?: string,
  placeholder?: string,
  inputStyle?: object,
  rules?: RulesProp,
  min?: number,
  max?: number,
  step?: number,
  precision?: number
}

const __default__ = {
  name: 'CInputNumber'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: {},
    label: {},
    placeholder: {},
    inputStyle: {},
    rules: {},
    min: {},
    max: {},
    step: { default: 1 },
    precision: {}
  },
  emits: ['update:value', 'focus', 'blur', 'input'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const state = reactive({
  message: '',
  error: false,
  required: false,
})
const onInput = (e) => {
  if (typeof props.min !== 'undefined' && e.target.value < props.min) {
    e.target.value = props.min
  }
  if (typeof props.max !== 'undefined' && e.target.value > props.max) {
    e.target.value = props.max
  }
  if (props.precision == 1) {
    e.target.value = e.target.value.replace(/[^0-9]/g, '')
  }
  emit('update:value', e.target.value)
  emit('input', e.target.value)
}
const onBlur = () => {
  validateInput()
  emit('blur')
}
const onFocus = () => {
  emit('focus')
}
const addNum = () => {
  let oldValue = Number(props.value || 0)
  let newValue = oldValue + props.step
  if (props.max || props.max == 0) {
    if (oldValue < props.max) {
      emit('update:value', newValue)
      emit('input', newValue)
    }
  } else {
    emit('update:value', newValue)
    emit('input', newValue)
  }

}
const subNum = () => {
  let oldValue = Number(props.value || 0)
  let newValue = oldValue - props.step
  if (props.min || props.min == 0) {
    if (oldValue > props.min) {
      emit('update:value', newValue)
      emit('input', newValue)
    }
  } else {
    emit('update:value', newValue)
    emit('input', newValue)
  }

}
const validateInput = (): boolean => {
  // 接收从父组件传递过来的验证规则（数组类型）
  if (props.rules) {
    // 调用数组的 every 方法，判断是否符合定义的表单验证规则
    const allPassed = props.rules.every(rule => {
      // 表单是否通过验证的标志
      let passed = true
      // 先将规则的提示信息赋值，如果表单验证失败，则会直接获得该message信息
      // 因为 every 只要有一个错误 就会返回错误，且其他数组不会再进行判断
      state.message = rule.message
      if (rule.required) {
        if (props.value) {
          passed = props.value?.toString().trim() !== ''
        } else {
          passed = false
        }

      }
      return passed
    })
    // 如果表单验证失败，则 allPassed 状态为 false 但是 state 对象中的 error应为 true
    // 所以 allPassed 取反赋值
    state.error = !allPassed
    // validateInput 方法的返回结果
    return allPassed
  }
  // 如果没有 props.rules 的表单规则 则返回 true
  return true
};
onMounted(() => {
  if (props.rules) {
    props.rules?.every(rule => {
      if (rule.required) {
        state.required = true
      }
    })
    emitter.emit("formItemCreated", validateInput)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (state.required)
            ? (_openBlock(), _createBlock(_component_svg_icon, {
                key: 0,
                class: "require-icon",
                icon: "require"
              }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.label) + ": ", 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        id: "inputNumber",
        type: "number",
        class: "c-input-control",
        style: _normalizeStyle({ ..._ctx.inputStyle }),
        value: _ctx.value,
        placeholder: _ctx.placeholder,
        onInput: onInput,
        onFocus: onFocus,
        onBlur: onBlur,
        min: _ctx.min,
        max: _ctx.max
      }, null, 44, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", {
          class: _normalizeClass(["btn-icon", { 'no-drop': Number(props.value) >= props.max! }]),
          onClick: _withModifiers(addNum, ["stop"])
        }, _hoisted_7, 2),
        _createElementVNode("span", {
          class: _normalizeClass(["btn-icon", { 'no-drop': Number(props.value) <= props.min! }]),
          onClick: _withModifiers(subNum, ["stop"])
        }, _hoisted_9, 2)
      ]),
      (state.error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(state.message), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})